/**
 * Flusso Dati — coreBOS `evDataFlow` (79x) on evo-gdpr.evolutivo.it.
 * Harvested from evo-mcp-limitless@origin/evo-policies by scripts/harvest/gen_descriptors.py.
 * Frameworks: gdpr. Type sources per field: docs/harvest-report.md.
 * Regenerate instead of hand-editing; hand edits belong in the generator's SPEC.
 */
export const dataFlowDescriptor = {
    slug: 'cmp_data_flow',
    kind: 'document',
    label: { singular: 'Flusso Dati', plural: 'Flussi Dati' },
    table: 'compliance_data_flow',
    idStrategy: 'sha256',
    fields: [
        { name: 'evdataflow_no', type: 'text', label: 'Evdataflow no' },
        { name: 'arttwentyeight', type: 'text', label: 'Arttwentyeight' },
        { name: 'description', type: 'text', label: 'Descrizione' },
        { name: 'dataflowname', type: 'text', label: 'Nome Flusso', required: true },
        { name: 'source', type: 'text', label: 'Sorgente' },
        { name: 'destination', type: 'text', label: 'Destinazione' },
        { name: 'data_categories', type: 'text', label: 'Categorie Dati' },
        { name: 'legal_basis', type: 'text', label: 'Base Giuridica' },
    ],
    relations: [
        { name: 'dflinktoprocact', kind: 'belongsTo', target: 'cmp_processing_activity' },
        { name: 'dflinktothird', kind: 'belongsTo', target: 'cmp_third_party' },
        { name: 'rel_account', kind: 'belongsTo', target: 'account', toEntitySpine: true },
        { name: 'assigned_user', kind: 'belongsTo', target: 'user', toEntitySpine: true },
    ],
    behaviors: { ownership: true, audit: true, softDelete: true, tenantScoped: true },
    ui: { mode: 'generated', icon: 'NodeIndexOutlined', navGroup: 'GDPR' },
};
